// 引入axios插件
import axios from "axios";
import { ElMessage } from "element-plus";
import fingerprintjs from "@fingerprintjs/fingerprintjs";
import { getToken } from "@/utils/utils.js"
async function getDeviceFingerprint() {
  let fp = await fingerprintjs.load();
  let result = await fp.get();
  let browserId = result.visitorId;
  localStorage.setItem("browserId", browserId);
  return browserId;
}
getDeviceFingerprint();

// 默认请求头
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";

// 创建axios实例
const myAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 300000,
});

// 请求拦截器
myAxios.interceptors.request.use(
  async (config) => {
    // console.log("config", config);
    // 在这里统一添加请求头，就不用每次调用接口的每次都手写了。如果token存在，那么添加token请求头。
    if (getToken()) {
      config.headers.token = getToken();
    }
    // 添加请求头，浏览器指纹
    if (localStorage.getItem("browserId")) {
      config.headers.fingerprint = localStorage.getItem("browserId");
    } else {
      config.headers.fingerprint = await getDeviceFingerprint();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
myAxios.interceptors.response.use(
  (res) => {
    // 如果是文件，那么不需要判断code状态码，直接返回即可
    if (res.request.responseType === "blob") {
      // 返回数据
      return res.data;
    }

    // 如果接口报错，那么在这里统一提示错误信息弹窗，并且抛出异常；如果接口正确，那么返回数据。
    if (res.data.code !== 200) {
      // 错误弹窗
      ElMessage({
        message: res.data.msg || "默认错误提示信息",
        type: "error",
        customClass: "my-el-message-box",
      });
      // 如果用户没有登录
      if (res.data.code === -1) {
        // 清空本地存储
        localStorage.clear();
        // 跳转到登录页面
        window.location.href = "/#/login/nowLogin";
      }
      // 抛出异常
      return Promise.reject(res.data);
    } else {
      // 返回数据
      return res.data;
    }
  },
  (error) => {
    // 错误弹窗
    ElMessage({
      message: error || "默认错误提示信息",
      type: "error",
      customClass: "my-el-message-box",
    });
    // 抛出异常
    return Promise.reject(error);
  }
);

export default myAxios;
